/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_TitleInputs */

const en_contact_title = /** @type {(inputs: Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk to us about your research`)
};

/**
* | output |
* | --- |
* | "Talk to us about your research" |
*
* @param {Contact_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_title = /** @type {((inputs?: Contact_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_title(inputs)
});